<ion-header translucent>
  <ion-toolbar>
    <ion-title>{{ 'Mobile.LinkVehicle' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item-divider sticky>
      <ion-label class="ion-text-wrap title">
        <h2>{{ callcard.title }}</h2>
      </ion-label>
    </ion-item-divider>

    <ion-item (click)="onAvailableResourceClicked()">
      <ion-label class="ion-text-wrap">
        <h2>
          <strong>{{ 'Mobile.AvailableResource' | translate }}</strong>
        </h2>
        <h3>{{ selectedVehicle ? selectedVehicle.VehicleCode : ('Mobile.SelectResource' | translate) }}</h3>
      </ion-label>
      <ion-icon slot="end" name="caret-down-outline"></ion-icon>
    </ion-item>

    <ion-item (click)="onPeopleCountClicked()">
      <ion-label>
        <h2>
          <strong>{{ 'Mobile.Engaged' | translate }}</strong>
        </h2>
        <h3>{{ peopleCount ? (peopleCount | number: '2.0-0') : ('Mobile.EnterNumber' | translate) }}</h3>
      </ion-label>
      <ion-icon slot="end" name="caret-down-outline"></ion-icon>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-button (click)="onDismiss()" color="danger">{{ 'Mobile.Cancel' | translate }}</ion-button>
  <ion-button [disabled]="!isValid()" (click)="onSubmit()" color="primary">{{ 'Mobile.Confirm' | translate }}</ion-button>
</ion-footer>
